/**
 * mk-wxopen-api
 * 微信开放平台api服务
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @description wxpublicAuthGet参数
  * @property `[authorizerAppId]` authorizerAppId授权方的appId信息，暂时不需要，后期可能会需要
  * @property `companyId` companyId：公司账户id
  * @property `scope` 授权范围：snsapi_base|snsapi_userinfo
  * @property `redirect` 回调地址
  */
export interface ParamswxpublicAuthGet {
  // queryParams
  /**
   * authorizerAppId授权方的appId信息，暂时不需要，后期可能会需要
   */
  authorizerAppId?: string;
  /**
   * companyId：公司账户id
   */
  companyId: string;
  /**
   * 授权范围：snsapi_base|snsapi_userinfo
   */
  scope: string;
  /**
   * 回调地址
   */
  redirect: string;
}
/**
  * @description wxpublicGetUserInfoGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `code` 授权code
  * @property `state` state
  * @property `appId` 客户公众号的appId
  */
export interface ParamswxpublicGetUserInfoGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 授权code
   */
  code: string;
  /**
   * state
   */
  state: string;
  /**
   * 客户公众号的appId
   */
  appId: string;
}
/**
  * @description wxpublicJsSDKSignGet参数
  * @property `companyId` 账户companyId，必填
  * @property `signUrl` signUrl，必填
  * @property `[appId]` 授权方appId，非必填
  */
export interface ParamswxpublicJsSDKSignGet {
  // queryParams
  /**
   * 账户companyId，必填
   */
  companyId: string;
  /**
   * signUrl，必填
   */
  signUrl: string;
  /**
   * 授权方appId，非必填
   */
  appId?: string;
}
/**
  */
export type ParamsBodywxpublicOpenCreatePost = models.WxpublicOpenCreateBody;

export class WeixinAuthApi {
  protected $basePath = '/wxopen/v1'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 微信 公众号授权
   * @param params ParamswxpublicAuthGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public wxpublicAuthGet = (
    params: ParamswxpublicAuthGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/wxpublic/auth';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('authorizerAppId' in params) p.query.authorizerAppId = params.authorizerAppId;
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('scope' in params) p.query.scope = params.scope;
    ajax.check(params.scope, 'scope');
    if ('redirect' in params) p.query.redirect = params.redirect;
    ajax.check(params.redirect, 'redirect');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 公众号授权-获取token
   * @param params ParamswxpublicGetUserInfoGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public wxpublicGetUserInfoGet = (
    params: ParamswxpublicGetUserInfoGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/wxpublic/getUserInfo';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('code' in params) p.query.code = params.code;
    ajax.check(params.code, 'code');
    if ('state' in params) p.query.state = params.state;
    ajax.check(params.state, 'state');
    if ('appId' in params) p.query.appId = params.appId;
    ajax.check(params.appId, 'appId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 公众号授权-获取分享Ticket
   * @param params ParamswxpublicJsSDKSignGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public wxpublicJsSDKSignGet = (
    params: ParamswxpublicJsSDKSignGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/wxpublic/jsSDKSign';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('signUrl' in params) p.query.signUrl = params.signUrl;
    ajax.check(params.signUrl, 'signUrl');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 创建开放平台关联公众号
   
   * @param data: ParamsBodywxpublicOpenCreatePost
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public wxpublicOpenCreatePost = (
    
    data: ParamsBodywxpublicOpenCreatePost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/wxpublic/open/create';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
}

export default new WeixinAuthApi();